<template>
    <div class="flex justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"
            viewBox="0 0 24 24"><!-- Icon from Meteor Icons by zkreations - https://github.com/zkreations/icons/blob/main/LICENSE -->
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M7 6h14M7 12h14M7 18h14M3 18" />
        </svg>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped></style>